import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: { color: theme.palette.primary.main },
    info: {margin: theme.spacing(4,0)}
  }),
);

export default useStyles;
